import { request } from '../request'

const search = {
    getHotList: data => request('/api/block/hot_search', 'get', data),
    getDefaultList: () => request('/api/block/default_search', 'get'),
    getSearchInfo: data => request('/api/block/recently_search', 'get', data),
    searchRecord: data => request('/api/block/search_record', 'get', data), // 添加一条搜索记录，用户搜索统计
}
export default search

